module.exports = __webpack_public_path__ + "img/hero-nav-portraits.97b1913e.jpg";